module.exports = __webpack_public_path__ + "static/media/handles-anti-scraping.63bbf753.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/handles-anti-scraping.svg
// module id = 433
// module chunks = 0